// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
/* tslint:disable */
/* eslint-disable */
import "../textstyles/fonts.css";
import "../reset.css";
import "./OptionSelectModal.Button.css";
import React, { createContext, useContext } from "react";
import {
  exists,
  findSetVariantProps,
  makeCompositeDefaultProps,
} from "../_internal_utils";
import { RootPrimitive, TextPrimitive } from "../_internal_primitives";

const styles = [
  {
    type: "default",
    layers: {
      AVanqqCPmY: {
        none: {
          text: "Text",
        },
      },
    },
  },
  {
    type: "enum",
    propName: "type",
    values: [
      {
        propValue: "warning",
        layers: {},
      },
      {
        propValue: "confirm",
        layers: {},
      },
    ],
  },
];

const defaultPropValues = [
  {
    type: "default",
    layers: {},
  },
  {
    type: "enum",
    propName: "type",
    values: [
      {
        propValue: "warning",
        layers: {},
      },
      {
        propValue: "confirm",
        layers: {},
      },
    ],
  },
];

const variantPropTypes = [
  {
    type: "enum",
    propName: "type",
    propValues: ["warning", "confirm"],
  },
];

export const ButtonContext = createContext(null);

function Button(_props) {
  const defaults = useContext(ButtonContext);
  const props = { ...defaults, ..._props };
  const activeVariants = findSetVariantProps(variantPropTypes, props);
  const getCompositeDefaultProps = makeCompositeDefaultProps(
    defaultPropValues,
    activeVariants
  );
  return (
    <RootPrimitive
      {...props}
      key="8gaSwGwp2L"
      addSpacing={false}
      internal={{
        projectId: "7X7HTLRqyD",
        styles: styles,
        layerId: "8gaSwGwp2L",
        scope: "VNP9TqNksx",
        activeVariants: activeVariants,
      }}
    >
      {(getStyle) => (
        <TextPrimitive
          id={"Text_AVanqqCPmY"}
          className={
            "__visly_reset_7X7HTLRqyD __visly_scope_VNP9TqNksx_AVanqqCPmY"
          }
          key={"AVanqqCPmY"}
          text={
            exists(props.text) ? props.text : getStyle("AVanqqCPmY", "text")
          }
          element={getStyle("AVanqqCPmY", "htmlElement")}
        />
      )}
    </RootPrimitive>
  );
}

Button.__variants = [
  {
    name: "type",
    type: "group",
    variants: ["warning", "confirm"],
  },
];

export default Button;
